import { Component, Input, Output, EventEmitter, OnInit, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';

@Component({
  selector: 'app-srv-filter',
  templateUrl: './srv-filter.component.html',
  styleUrls: ['./srv-filter.component.scss']
})
export class SrvFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listFilterSrv: any[];
  optionSelected: any = null;


  @Input() srvData: any;
  @Input() srvSelected: any;
                      
  constructor() {
    super();
  }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if ('srvData' in changes) {
      this.listFilterSrv = this.srvData ? this.srvData : [];
      // Se abbiamo già un valore selezionato, assicuriamoci che sia nella lista
      this.ensureSelectedValueInList();
      if (!this.optionSelected && !this.srvSelected) {
        this.optionSelected = null;
      }
    }
    if ('srvSelected' in changes) {
      this.optionSelected = this.srvSelected || null;
      // Assicuriamoci che il valore selezionato sia nella lista
      this.ensureSelectedValueInList();
    }
  }

  private ensureSelectedValueInList(): void {
    if (this.optionSelected && this.listFilterSrv && this.listFilterSrv.length > 0) {
      if (!this.listFilterSrv.includes(this.optionSelected)) {
        // Aggiungi il valore alla lista se non è presente
        this.listFilterSrv = [...this.listFilterSrv, this.optionSelected];
      }
    }
  }

  ngOnDestroy(): void { }

}
